import { Importance } from "@blisspointmedia/bpm-types/dist/Creative";
import { randomColorPart } from "../utils/colors";

export const getFillColors = (
  attributeImportanceData: Importance[],
  suppressedAttributes: Set<string>
): Map<string, string> => {
  const seriesColors: string[] = [
    "#aa69e7",
    "#f8369a",
    "#fc8b08",
    "#4dd0e1",
    "#ff77a9",
    "#00a0af",
    "#c4001d",
    "#9e00c5",
    "#ffe330",
    "#efc700",
    "#ff4c64",
    "#d400f9",
    "#00a0df",
    "#691b9a",
    "#ff6f00",
    "#ffb032",
    "#e91e62",
    "#3d5afe",
    "#4c8bff",
    "#ff8e4c",
    "#ff4ca6",
    "#4cfff9",
  ];
  const overflowColors: Record<string, string> = {};
  const getSeriesColorGreenExcluded = (i: number): string => {
    if (i < seriesColors.length) {
      return seriesColors[i];
    }
    if (overflowColors[`${i}`]) {
      return overflowColors[`${i}`];
    }
    const newRandomColor = `#${randomColorPart()}${50}${randomColorPart()}`;
    overflowColors[`${i}`] = newRandomColor;
    return newRandomColor;
  };

  let colors: Map<string, string> = new Map();
  for (let i = 0; i < attributeImportanceData.length; i++) {
    let attributeName = attributeImportanceData[i].name;
    if (!suppressedAttributes.has(attributeName)) {
      colors.set(attributeName, getSeriesColorGreenExcluded(i));
    }
  }

  return colors;
};
